import SessionStorage from '../../helpers/sessionStorage'


const microsoftOAuth = {

    generateCodeChallenge() {
        const codeVerifier = generateCodeVerifier()
        const codeChallenge = generateCodeChallenge(codeVerifier)

        // Store the code verifier in session storage for later use
        SessionStorage.setItem('oAuthCodeVerifier', codeVerifier)

        return codeChallenge
    },

    getOAuthStep1Data() {
        return {
            oAuthCodeVerifier: SessionStorage.getItem('oAuthCodeVerifier'),
            email: SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        }
    }

}


export default microsoftOAuth

// Private

function generateCodeVerifier() {
    const crypto = require('crypto')

    const array = new Uint8Array(32)
    crypto.randomFillSync(array)
    return array.join('')
}
function generateCodeChallenge(codeVerifier) {
    const crypto = require('crypto')

    const hash = crypto.createHash('sha256')
    hash.update(codeVerifier)
    const base64 = hash.digest('base64')
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}